<section>
    <div class="row">
        <div class="col-md-8">
            <img src="../../../assets/images/404mob.jpg" alt="" width="100%">
        </div>
        <div class="col-md-4">
            <div class="sec">
                <h2>{{'Désolé' | translate}}&nbsp;!</h2>
                <h1>{{'Page non trouvée' | translate}}</h1>
                <p>{{'Nous sommes désolés de ne pouvoir traiter votre demande' | translate}}</p>
                <button [routerLink]="['/']">Aller à la page d'accueil</button>
            </div>
        </div>
    </div>
</section>
